import React from 'react';

export default class MissionLaunch extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const mission = this.props.mission;

		return (
			<React.Fragment>
				<h4>LAUNCHING YOUR MISSION</h4>
				<p>Launching your mission means that people can begin to post distances and see their progress.</p>
				<p>You will need to launch the mission from the mission page after it has been created.</p>
				<p>You can begin to onboard participants to the mission at any time after it has been created.</p>
				{/*<p>How would you like to launch your mission?</p>
				}<div className="box mission-type-option">
					<label className="radio">
						<input type="radio" name="launchType" onChange={this.props.handleChange} value="manual" checked={mission.launchType=='manual' ? true : false} style={{marginTop: 4}}  tabIndex="7" />
						<h4>Launch later</h4>
						<p>This will mean you can manually launch your mission whenever you want</p>
					</label>
				</div>
				
				<div className="box mission-type-option">
					<label className="radio">
						<input type="radio" name="launchType" onChange={this.props.handleChange} value="automatic" checked={mission.launchType=='automatic' ? true : false} style={{marginTop: 4}} />
						<div>
							<h4>Launch now</h4>
							<p>Launch the mission with a starting time of today.</p>
						</div>
					</label>
				</div> */}
				<br />
			</React.Fragment>
		)
	}
}